module.exports = __webpack_public_path__ + "img/accessory_item_09.231379a0.svg";